import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";
import DeleteIcon from "@mui/icons-material/Delete";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import PolylineIcon from "@mui/icons-material/Polyline";
import RectangleOutlinedIcon from "@mui/icons-material/RectangleOutlined";
import { IconButton } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { DrawSymbol } from "./DrawStyles.helper";
import Graphic from "@arcgis/core/Graphic";

interface SketchToolsParams {
  view: any;
  map: any;
}

const SketchTools: React.FC<SketchToolsParams> = ({ view, map }) => {
  const mapDiv = useRef(null);
  const [graphicsLayer, setGraphicsLayer] = useState<GraphicsLayer>();
  const [sketchVM, setSketchVM] = useState<any>();

  useEffect(() => {
    if (!map) return;
    const gl = map.findLayerById("draw");
    if (gl instanceof GraphicsLayer) {
      setGraphicsLayer(gl);
    }
  }, [map, view]);

  useEffect(() => {
    if (!graphicsLayer) return;

    const sketch = new SketchViewModel({
      view: view,
      layer: graphicsLayer,
    });
    setSketchVM(sketch);
  }, [graphicsLayer]);

  useEffect(() => {
    if (!sketchVM) return;
    sketchVM.on("create", (event: any) => {
      if (event.state !== "complete") return;
      const graphic: Graphic = event.graphic;

      graphic.attributes = {
        name: "Custom geometry",
        
      };
      graphic.symbol = DrawSymbol(graphic.geometry.type, "sketch")
    
      console.log("Attributes added:", graphic.attributes);
    });
  }, [sketchVM]);

  return (
    <>
      <IconButton
        aria-label="draw point"
        color="primary"
        onClick={() => sketchVM.create("point")}
      >
        <PlaceOutlinedIcon />
      </IconButton>
      <IconButton
        aria-label="draw polyline"
        color="primary"
        onClick={() => sketchVM.create("polyline")}
      >
        <PolylineIcon />
      </IconButton>
      <IconButton
        aria-label="draw polygon"
        color="primary"
        onClick={() => sketchVM.create("polygon")}
      >
        <RectangleOutlinedIcon />
      </IconButton>
      <IconButton
        aria-label="clear graphic layer"
        color="primary"
        onClick={() => graphicsLayer?.removeAll()}
      >
        <DeleteIcon />
      </IconButton>
      <div ref={mapDiv}></div>
    </>
  );
};

export default SketchTools;
